import { MSG_NAME_FROM_IFRAME } from './handleIframeMessage/handleIframeMessage';

export const QA_ASSISTANT_NOTIFICATION_ID = 'qaAssistantNotification' as const;
export const ACTIVE_CLASS = 'active' as const;
export const QA_ASSISTANT_NOTIFICATION_EVENT = 'qa-assistant-notification-event' as const;

export const createABTastyNotificationListener = () => {
  const listener = ({ data }) => {
    if (!data) return;
    if (data.name === MSG_NAME_FROM_IFRAME.QaAssistantEventNotification) {
      const isValueNumber = typeof data.value === 'number';

      const notification = document.getElementById(QA_ASSISTANT_NOTIFICATION_ID) as HTMLElement;
      if (data.value && isValueNumber && !notification.className.includes('active')) {
        notification.classList.add(ACTIVE_CLASS);
      } else if (!data.value) {
        notification.classList.remove(ACTIVE_CLASS);
      }

      if (isValueNumber) {
        notification.innerHTML = data.value > 9 ? '9+' : data.value.toString();
      }
    }
  };

  window.addEventListener('message', listener);

  return listener;
};

export const insertABtastyEventNotification = (logo: HTMLElement) => {
  const notification = document.createElement('div');
  notification.setAttribute('id', QA_ASSISTANT_NOTIFICATION_ID);
  notification.classList.add(QA_ASSISTANT_NOTIFICATION_EVENT);

  logo!.append(notification!);
};
